export const PRICE_VS_ODO_CHART = Object.freeze("priceAndOdo");
export const AVG_PRICE_AND_ODO_CHART = Object.freeze("avgPriceAndOdo");
export const DEPRECATION_CHART = Object.freeze("depreciation");
export const GROUP = Object.freeze({
    DECODE: "decode",
    POLICE: "police",
    WRECKAGE: "wreckage",
    CHART: "chart",
    CARVAGO: "carvago"
});
export const DECODE_GLOBAL = Object.freeze("global");